import React, { useState } from 'react';
import { useLocalization } from '../../contexts/LocalizationContext';
import { useSubscription } from '../../contexts/SubscriptionContext';
import CommunityHeader from '../../components/community/CommunityHeader';
import ForumsSection from '../../components/community/ForumsSection';
import { CommunityEventsSection } from '../../components/community/communityEvents';
import NetworkSection from '../../components/community/NetworkSection';
import FeatureAccessPlaceholder from '../../components/subscription/FeatureAccessPlaceholder';
import { MessageCircle, Users, Calendar } from 'lucide-react';

const Community: React.FC = () => {
  const { language, isRTL } = useLocalization();
  const { isFeatureAvailable } = useSubscription();
  const [activeTab, setActiveTab] = useState<'forums' | 'events' | 'network'>('forums');
  const [searchQuery, setSearchQuery] = useState('');

  // Check if user has access to community features
  const hasCommunityAccess = isFeatureAvailable('community');

  const handleTabChange = (tab: 'forums' | 'events' | 'network') => {
    setActiveTab(tab);
  };

  const handleSearchChange = (query: string) => {
    setSearchQuery(query);
  };

  const handleSearchSubmit = () => {
    // Search functionality is handled by individual sections
    console.log('Search submitted:', searchQuery);
  };

  const renderActiveSection = () => {
    switch (activeTab) {
      case 'forums':
        return <ForumsSection searchQuery={searchQuery} />;
      case 'events':
        return <CommunityEventsSection searchQuery={searchQuery} />;
      case 'network':
        return <NetworkSection searchQuery={searchQuery} />;
      default:
        return <ForumsSection searchQuery={searchQuery} />;
    }
  };


  // Show placeholder if user doesn't have access
  if (!hasCommunityAccess) {
    return (
      <FeatureAccessPlaceholder
        featureName="Community"
        featureNameAr="المجتمع"
        description="Connect with other lawyers, share experiences, and participate in forums and events."
        descriptionAr="تواصل مع المحامين الآخرين، شارك الخبرات، وشارك في المنتديات والأحداث."
        icon={<MessageCircle className="w-12 h-12 text-white" />}
      />
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <CommunityHeader
          activeTab={activeTab}
          onTabChange={handleTabChange}
          searchQuery={searchQuery}
          onSearchChange={handleSearchChange}
          onSearchSubmit={handleSearchSubmit}
        />

        {/* Content */}
        <div className="mt-8">
          {renderActiveSection()}
        </div>
      </div>
    </div>
  );
};

export default Community;